import { render, staticRenderFns } from "./baseExportPage.vue?vue&type=template&id=9dec4344&scoped=true"
import script from "./baseExportPage.vue?vue&type=script&lang=js"
export * from "./baseExportPage.vue?vue&type=script&lang=js"
import style0 from "./baseExportPage.vue?vue&type=style&index=0&id=9dec4344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dec4344",
  null
  
)

export default component.exports